import React from "react";
import styled from "styled-components";
import { format } from "date-fns";


const FormTextAreaComponent = ({
  label,
  type,
  name,
  value,
  onChange,
  onBlur,
  error,
  placeholder,
  defaultValue,
  max,
}) => {
  return (
    <StyledFormInputComponent>
      {label && (
        <label htmlFor={name} className="form-font form-label">
          {label}
        </label>
      )}
      <textarea
        type={type}
        id={name}
        max={max && type === "date" ? format(max, "yyyy-MM-dd") : null}
        placeholder={placeholder}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        onWheel={type === "number" ? (e) => e.target.blur() : undefined}
        value={value || defaultValue}
        className="form-font"
        rows={5}
        cols={5}
      />
      {error && <div className="form-error">{error}</div>}
    </StyledFormInputComponent>
  );
};

const StyledFormInputComponent = styled.div`
  margin-bottom: 2.4rem;
  textarea {
    display: inline-block;
    font-size: 1.6rem;
    background: transparent;
    -webkit-appearance: none;
    min-width: 32rem;
    border: none;
    height: 4.8rem;
    padding-bottom: 0rem;
    padding-left: 1rem;
    border: 1px solid rgba(33, 51, 79, 0.15) !important;
  }
  textarea:active{
  border: 1px solid green !important;
}
textarea:focus{
  border: 1px solid green !important;
}

  @media only screen and (max-width: 405px) {
    textarea {
      min-width: 100%;
    }
  }
`;

export default FormTextAreaComponent;
